// extracted by mini-css-extract-plugin
export default {"actions":"ComplainOverviewStep_actions__YJ2fh","status":"ComplainOverviewStep_status__x3nHG","reasons":"ComplainOverviewStep_reasons__1+FYH"};